import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import { ErrorBoundary } from 'sharedComponents';
import { withConfig } from 'shell/hoc/withConfig';

import RestrictedPage from '../../pages/RestrictedPage';

export const PrivateRoute = ({ user, path, component: Comp, exact, lazy, config, componentProps = {} }) => {
  const accessControlMapping = config.get('accessControlMapping');

  if (accessControlMapping[path] && !accessControlMapping[path].includes(user.role)) {
    return <RestrictedPage />;
  }

  return (
    <Route
      path={path}
      exact={exact}
      render={(props) =>
        lazy ? (
          <Suspense fallback={<div />}>
            <ErrorBoundary>
              <Comp {...componentProps} {...props} />
            </ErrorBoundary>
          </Suspense>
        ) : (
          <ErrorBoundary>
            <Comp {...componentProps} {...props} />
          </ErrorBoundary>
        )
      }
    />
  );
};

export default withConfig()(PrivateRoute);
